import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-chip-list',
  templateUrl: './filter-chip-list.component.html',
  styleUrls: ['./filter-chip-list.component.scss'],
  standalone: false
})
export class FilterChipListComponent {

  @Input()
  public values: string[];

  @Input()
  public group: FormGroup = new FormGroup({});

  @Input()
  public display: (value: string) => string = (value) => value;

  public getControl(value: string) {
    return this.group.get(value);
  }

  public toggleChip(value: string): void {
    const control = this.getControl(value);
    control.setValue(!control.value);
  }
}
